import styled, { css } from 'styled-components';

export const Container = styled.div`
  touch-action: none;
  height: 100%;
`;

export const Wrapper = styled.div<{ z: number }>`
  transition: transform linear 100ms;
  will-change: transform;
  height: 100%;
  display: flex;
  align-items: center;

  ${({ z }) =>
    z !== 1
      ? css`
          cursor: grab;
        `
      : ''}
`;

export const Image = styled.img<{ translateX: number; translateY: number; scale: number }>`
  transform-origin: 0 0;
  transform: scale(${(props) => props.scale})
    translate(${(props) => props.translateX}px, ${(props) => props.translateY}px);
  transition: transform 0.2s ease-out;
  will-change: transform;
`;
